window.KnifeCustomizationState = {
    selectedShape: null,
    selectedBlade: null,
    selectedBladeData: null,
    selectedHandle: null,
    selectedHandleData: null,
    setSelectedShape: null,
    setSelectedBlade: null,
    setSelectedHandle: null,
    activeAccordion: 'shape',
    setActiveAccordion: null,
    allBlades: [],
    allHandles: [],
    allShapes: []
};

var SHAPE_TO_TAG = {
    'santoku': 'Santoku',
    'nakiri': 'Nakiri',
    'gyuto': 'Gyuto',
    'bunka': 'Bunka',
    'kobunka': 'Kobunka',
    'petty': 'Petty',
    'kiritsuke-petty': 'Kiritsuke Petty',
    'kiritsuke': 'Kiritsuke'
};

var TAG_TO_SHAPE = {
    'Santoku': 'santoku',
    'Nakiri': 'nakiri',
    'Gyuto': 'gyuto',
    'Bunka': 'bunka',
    'Kobunka': 'kobunka',
    'Petty': 'petty',
    'Kiritsuke Petty': 'kiritsuke-petty',
    'Kiritsuke': 'kiritsuke'
};

var DEFAULT_HANDLE_PREVIEW_SHAPE = 'santoku';

var mockKnifeShapes = [
    { id: 'santoku', name: 'Santoku', description: 'The Santoku is a versatile Japanese all-purpose knife, perfect for slicing, dicing, and mincing vegetables, fish, and meat with precision.', image: '' },
    { id: 'nakiri', name: 'Nakiri', description: 'The Nakiri is a Japanese vegetable knife with a flat blade profile, designed for precise up-and-down chopping of vegetables.', image: '' },
    { id: 'gyuto', name: 'Gyuto', description: 'The Gyuto is the Japanese equivalent of a Western chef knife, offering versatility for all kitchen tasks from slicing to fine dicing.', image: '' },
    { id: 'bunka', name: 'Bunka', description: 'A versatile all-rounder designed for both precision and power. The Bunka distinct reverse tanto tip allows for detailed work like slicing herbs or vegetables, while its broad blade excels at chopping and cutting meats.', image: '' },
    { id: 'kobunka', name: 'Kobunka', description: 'The Kobunka is a smaller version of the Bunka, offering the same versatile design in a more compact form for detailed work and smaller hands.', image: '' },
    { id: 'petty', name: 'Petty', description: 'The Petty is a small utility knife perfect for intricate tasks like peeling, trimming, and detailed cutting work.', image: '' },
    { id: 'kiritsuke-petty', name: 'Kiritsuke Petty', description: 'The Kiritsuke Petty combines the elegant clipped tip of a Kiritsuke with the compact utility of a Petty knife for versatile precision work.', image: '' },
    { id: 'kiritsuke', name: 'Kiritsuke', description: 'The Kiritsuke is a prestigious Japanese knife traditionally reserved for executive chefs, combining the functions of both Yanagiba and Usuba.', image: '' }
];

var shapeImages = {
    santoku: 'https://cdn.shopify.com/s/files/1/0947/2773/3619/files/shape-santoku.png?v=1769401464',
    nakiri: 'https://cdn.shopify.com/s/files/1/0947/2773/3619/files/shape-nakiri.png?v=1769401464',
    gyuto: 'https://cdn.shopify.com/s/files/1/0947/2773/3619/files/shape-gyuto.png?v=1769401464',
    bunka: 'https://cdn.shopify.com/s/files/1/0947/2773/3619/files/shape-bunka.png?v=1769401464',
    kobunka: 'https://cdn.shopify.com/s/files/1/0947/2773/3619/files/shape-kobunka.png?v=1769401464',
    petty: 'https://cdn.shopify.com/s/files/1/0947/2773/3619/files/shape-petty.png?v=1769401464',
    'kiritsuke-petty': 'https://cdn.shopify.com/s/files/1/0947/2773/3619/files/shape-kiritsuke-petty.png?v=1769401464',
    kiritsuke: 'https://cdn.shopify.com/s/files/1/0947/2773/3619/files/shape-kiritsuke.png?v=1769401464'
};

var BLADE_SPECS_CONFIG = [
    { key: 'custom.product_name_japanese', label: 'Product Name (Japanese)' },
    { key: 'my_fields.blade_type', label: 'Blade Type' },
    { key: 'custom.blade_shape', label: 'Blade Shape' },
    { key: 'custom.blade_use', label: 'Use' },
    { key: 'my_fields.blade_material', label: 'Blade Material' },
    { key: 'my_fields.material_detail', label: 'Material Detail' },
    { key: 'my_fields.blade_finish', label: 'Blade Finish' },
    { key: 'my_fields.finish_detail', label: 'Finish Detail' },
    { key: 'my_fields.hrc', label: 'HRC' },
    { key: 'my_fields.weght', label: 'Weight' },
    { key: 'custom.total_length', label: 'Total Length' },
    { key: 'my_fields.blade_length', label: 'Blade Length' },
    { key: 'custom.blade_width', label: 'Blade Width' },
    { key: 'custom.blade_height', label: 'Blade Height' },
    { key: 'my_fields.blade_thickness', label: 'Blade Thickness' },
    { key: 'custom.spine_length', label: 'Spine Length' },
    { key: 'custom.spine_thickness', label: 'Spine Thickness' },
    { key: 'custom.handle_length', label: 'Handle Length (Recommended)' },
    { key: 'my_fields.origin', label: 'Origin' },
    { key: 'my_fields.availability_sheath', label: 'Sheath Availability' }
];

var HANDLE_SPECS_CONFIG = [
    { key: 'custom.handle_length', label: 'Handle Length' },
    { key: 'my_fields.weght', label: 'Weight' },
    { key: 'custom.handle_thickness', label: 'Handle Thickness (Top)' },
    { key: 'custom.handle_thickness_bottom', label: 'Handle Thickness (Bottom)' },
    { key: 'custom.ferrule_length', label: 'Ferrule Length' },
    { key: 'custom.tang_size', label: 'Tang Size' },
    { key: 'my_fields.material_detail', label: 'Material Detail' },
    { key: 'custom.colour', label: 'Colour' },
    { key: 'my_fields.finish_detail', label: 'Finish Detail' },
    { key: 'custom.handle_end', label: 'Handle End' }
];

function formatPrice(price) {
    if (window.CurrencyFormat && window.CurrencyFormat.formatMoney) {
        return window.CurrencyFormat.formatMoney(price);
    }
    return '¥' + price.toLocaleString() + ' JPY';
}

function preloadImages(imageUrls) {
    var validUrls = imageUrls.filter(function(url) { return url && url.length > 0; });
    if (validUrls.length === 0) {
        return Promise.resolve();
    }
    var promises = validUrls.map(function(url) {
        return new Promise(function(resolve) {
            var img = new Image();
            img.onload = resolve;
            img.onerror = resolve;
            img.src = url;
        });
    });
    return Promise.all(promises);
}

function preloadSingleImage(imageUrl) {
    return new Promise(function(resolve) {
        if (!imageUrl || imageUrl.length === 0) {
            resolve(true);
            return;
        }
        var img = new Image();
        img.onload = function() { resolve(true); };
        img.onerror = function() { resolve(true); };
        img.src = imageUrl;
    });
}

function getShapeFromBladeTags(tags) {
    if (!tags || !Array.isArray(tags)) return null;
    for (var i = 0; i < tags.length; i++) {
        if (TAG_TO_SHAPE[tags[i]]) {
            return TAG_TO_SHAPE[tags[i]];
        }
    }
    return null;
}

function bladeMatchesShape(blade, shapeId) {
    if (!blade || !blade.tags || !shapeId) return false;
    var shapeTag = SHAPE_TO_TAG[shapeId];
    return blade.tags.includes(shapeTag);
}

function getCompatibleShapesFromHandle(handle) {
    if (!handle || !handle.tags || !Array.isArray(handle.tags)) return [];
    var compatibleShapes = [];
    handle.tags.forEach(function(tag) {
        if (tag.startsWith('fits-')) {
            var shapeId = tag.replace('fits-', '');
            if (SHAPE_TO_TAG[shapeId]) {
                compatibleShapes.push(shapeId);
            }
        }
    });
    return compatibleShapes;
}

function handleFitsShape(handle, shapeId) {
    if (!handle || !shapeId) return false;
    var compatibleShapes = getCompatibleShapesFromHandle(handle);
    return compatibleShapes.includes(shapeId);
}

function bladeCompatibleWithHandle(blade, handle) {
    if (!blade || !handle) return true;
    var bladeShape = getShapeFromBladeTags(blade.tags);
    if (!bladeShape) return true;
    return handleFitsShape(handle, bladeShape);
}

function handleHasBladeRestrictions(handle) {
    if (!handle || !handle.tags) return false;
    return handle.tags.includes('ocean');
}

function bladeFitsHandle(blade, handle) {
    if (!blade || !handle) return true;
    if (!handleHasBladeRestrictions(handle)) return true;
    return blade.tags && blade.tags.includes('fits-ocean');
}

function handleFitsBlade(handle, blade) {
    if (!handle || !blade) return true;
    if (!handleHasBladeRestrictions(handle)) return true;
    return blade.tags && blade.tags.includes('fits-ocean');
}

function getHandlePreviewImage(handle, shapeId) {
    if (!handle || !handle.metafields) return (handle && handle.image) || '';
    var shape = shapeId || DEFAULT_HANDLE_PREVIEW_SHAPE;
    var metafieldKey = 'custom.handle_' + shape.replace('-', '_') + '_preview';
    return handle.metafields[metafieldKey] || 
           handle.metafields['custom.handle_' + DEFAULT_HANDLE_PREVIEW_SHAPE + '_preview'] || 
           handle.image || 
           '';
}

// only return specs with values
function getSpecifications(product, imageType) {
    var metafields = product.metafields || {};
    var specsConfig = imageType === 'blade' ? BLADE_SPECS_CONFIG : imageType === 'handle' ? HANDLE_SPECS_CONFIG : [];
    return specsConfig
        .filter(function(spec) {
            var value = metafields[spec.key];
            return value !== null && value !== undefined && value !== '';
        })
        .map(function(spec) {
            return { label: spec.label, value: metafields[spec.key] };
        });
}

function getRecommendedHandles(product) {
    if (!product.metafields) return [];
    return product.metafields['custom.recommended_handles'] || [];
}

window.getHandlePreviewImage = getHandlePreviewImage;
window.getShapeFromBladeTags = getShapeFromBladeTags;
window.DEFAULT_HANDLE_PREVIEW_SHAPE = DEFAULT_HANDLE_PREVIEW_SHAPE;